import * as React from 'react';
import './Roadmap.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../stores';
import RoadmapService from '../../../services/RoadmapService';
import { Pivot } from '../../pivot/Pivot';
import StatusSheetPanel from './statusSheetPanel/StatusSheetPanel';
import moment = require('moment');
import ProductService from '../../../services/ProductService';
import { ITeam } from '../../../interfaces/ITeam';

export interface IProps {
  open: boolean;
  close: () => void;
  appStore?: AppStore;
}

export interface IState {
  showButtons: boolean;
  selectedPivot?: string;
  hasAccess?: boolean;
}

@inject('appStore')
@observer
export default class Roadmap extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      showButtons: false,
      selectedPivot: "roadmap",
      hasAccess: this.props.appStore!.user?.userType === "admin" ? true : undefined
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (this.props.open !== props.open && props.open) {
      ProductService.productAccess("3144", this.props.appStore!.user?.username).then((program: any) => {
        if (program?.results?.[0]?.team) {
          ProductService.getTeam(program.results[0].team).then((teams: ITeam[]) => {
            if (teams?.[0]?.roadmapEnabled) {
              this.setState({ hasAccess: true });
            }
          });
        }
      });
      setTimeout(() => {
        this.setState({ showButtons: true });
      }, 500);
    }
  }

  private answer(questionId: number, answer: string): void {
    this.props.appStore!.roadmap.answers[questionId] = answer;
  }

  private isRoadmapValid(): boolean {
    let roadmapIsValid = true;
    if (!this.props.appStore!.roadmap) {
      roadmapIsValid = false;
    } else {
      this.props.appStore!.roadmap?.answers?.forEach((answer, index) => {
        if ((answer === null || answer === undefined || answer === "") && index > 0) {
          roadmapIsValid = false;
        }
      });
    }
    return roadmapIsValid;
  }

  render() {
    return (
      <div
        className='roadmap'
        style={{
          top: this.props.appStore!.showRoadmap ? (this.props.appStore!.isMobile ? 0 : 50) : screen.height,
          height: this.props.appStore!.podcastToPlay ? (this.props.appStore!.isMobile ? "calc(100% - 101px)" : "calc(100% - 151px)") : (this.props.appStore!.isMobile ? "100%" : "calc(100% - 50px)")
        }}
      >
        <>
          <div className="roadmapCover">
            <div
              className="roadmapCoverImage"
              style={{
                backgroundImage: `url(https://dojo.mindjuice.com/images/roadmap-header.png)`
              }}
            />
          </div>
          <div className='roadmapContentWrapper'>
            {this.state.showButtons &&
              <div
                className='closeButton'
                onClick={() => {
                  this.setState({ showButtons: false, selectedPivot: "roadmap" });
                  this.props.appStore!.showRoadmap = undefined;
                  //history.back();
                }}
              />
            }
            {this.state.showButtons && this.state.selectedPivot === "roadmap" &&
              <div
                className='saveRoadmapButton'
                onClick={() => {
                  console.log(this.props.appStore!.roadmap)
                  if (this.props.appStore!.roadmap?.objectId) {
                    RoadmapService.updateRoadmap(this.props.appStore!.roadmap, this.props.appStore!.user);
                  } else {
                    RoadmapService.createRoadmap({
                      answers: this.props.appStore!.roadmap?.answers,
                      userId: this.props.appStore!.user.id,
                      ACL: JSON.parse(`{
                    "*": { "read": false },
                  "${this.props.appStore!.user?.id}": {"read": true, "write": true }
                  }`)
                    })
                  }
                }}
              >
                {window.loc.strings.saveRoadmap}
              </div>
            }
            {/* {this.props.appStore!.editMode &&
              <div
                className='adminButton'
                style={{
                  right: 62
                }}
                onClick={() => {

                }}
              >
                Rediger
              </div>
            }
            {this.props.appStore!.editMode &&
              <div
                className='adminButton'
                style={{
                  right: 165
                }}
                onClick={() => {

                }}
              >
                Adgang
              </div>
            } */}
            <div className='roadmapContent'>
              <div className="roadmapQuestions">
                <Pivot
                  highlightColor="#ffffff"
                  textColor="#999999"
                  items={[
                    {
                      key: "roadmap",
                      text: window.loc.strings.roadmap,
                    },
                    {
                      key: "statusSheets",
                      text: window.loc.strings.weeklyStatusSheets,
                      disabled: !this.isRoadmapValid()
                    }
                  ]}
                  style={{
                    fontSize: "14px",
                    textTransform: "uppercase"
                  }}
                  selectedKey={this.state.selectedPivot}
                  select={(selectedPivot: string) => {
                    this.setState({ selectedPivot });
                    if (selectedPivot === "statusSheets") {
                      RoadmapService.getStatusSheets(this.props.appStore!.user).then((statusSheets) => {
                        if (statusSheets) {
                          this.props.appStore!.statusSheets = statusSheets;
                        } else {
                          this.props.appStore!.statusSheets = [];
                        }
                      });
                    }
                  }}
                />
                {this.state.selectedPivot === "statusSheets" &&
                  <>
                    <>
                      {this.props.appStore!.statusSheets?.map((statusSheet, index) => {
                        return (
                          <div
                            className='statusSheet'
                            key={statusSheet.objectId}
                            onClick={() => this.props.appStore!.statusSheetToEdit = statusSheet}
                          >
                            {`${window.loc.strings.statusSheetForWeek} ${statusSheet.weekNumber}`}
                          </div>
                        )
                      })}
                    </>
                    <div
                      className='newStatusSheetButton'
                      onClick={() => {
                        this.props.appStore!.statusSheetToEdit = {
                          id: "new",
                          answers: new Array(10),
                          weekNumber: moment().format('w'),

                        };
                      }}
                    >
                      {window.loc.strings.newStatusSheet}
                    </div>
                  </>
                }
                {this.state.selectedPivot === "roadmap" &&
                  <>
                    {(this.state.hasAccess) ?
                      <>
                        <div className="roadmapQuestion">
                          <label>1) Dit formål (Min Nordstjerne)? Dit dybeste hvorfor. Det hvorfor der ligger nedenunder alle dine intentioner</label>
                          <textarea
                            onChange={(event: any) => this.answer(1, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[1]}
                          />
                        </div>
                        <h3>De værdier som skal vejlede dine handlinger i år</h3>
                        <div className="roadmapQuestion">
                          <label>2) Stretch value</label>
                          <textarea
                            onChange={(event: any) => this.answer(2, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[2]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>3) Stretch value</label>
                          <textarea
                            onChange={(event: any) => this.answer(3, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[3]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>4) Stretch value</label>
                          <textarea
                            onChange={(event: any) => this.answer(4, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[4]}
                          />
                        </div>
                        <h3>Dine ord for i år</h3>
                        <div className="roadmapQuestion">
                          <label>5) Dit styrkende mantra for i år</label>
                          <textarea
                            onChange={(event: any) => this.answer(5, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[5]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>6) Dine styrkende ord for i år</label>
                          <textarea
                            onChange={(event: any) => this.answer(6, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[6]}
                          />
                        </div>
                        <h2>Vælg Den Magiske Rækkefølge på dine 3 livsområder fra dit Stressbarometer (husk Domino-effekten med lettest først)</h2>
                        <h3>1. Livsområde</h3>
                        <div className="roadmapQuestion">
                          <label>7) 1. Livsområde Det livsområde du har valgt at fokusere på, som det vigtigste i år</label>
                          <textarea
                            onChange={(event: any) => this.answer(7, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[7]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>8) 1. Livsområde: Drøm Hvad er din drøm indenfor dit første livsområde?</label>
                          <textarea
                            onChange={(event: any) => this.answer(8, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[8]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>9) 1. Livsområde: Mål om 5 år Hvad er dit mål om 5 år indenfor dit første livsområde?</label>
                          <textarea
                            onChange={(event: any) => this.answer(9, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[9]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>10) 1. Livsområde: Mål om 1 år (Kun ét) Hvad er dit mål om 1 år indenfor dit første livsområde?</label>
                          <textarea
                            onChange={(event: any) => this.answer(10, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[10]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>11) Delmål (indenfor 1. livsområde) Om 11 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(11, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[11]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>12) Delmål (indenfor 1. livsområde) Om 10 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(12, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[12]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>13) Delmål (indenfor 1. livsområde) Om 9 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(13, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[13]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>14) Delmål (indenfor 1. livsområde) Om 8 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(14, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[14]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>15) Delmål (indenfor 1. livsområde) Om 7 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(15, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[15]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>16) Delmål (indenfor 1. livsområde) Om 6 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(16, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[16]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>17) Delmål (indenfor 1. livsområde) Om 5 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(17, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[17]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>18) Delmål (indenfor 1. livsområde) Om 4 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(18, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[18]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>19) Delmål (indenfor 1. livsområde) Om 3 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(19, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[19]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>20) Delmål (indenfor 1. livsområde) Om 2 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(20, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[20]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>21) Delmål (indenfor 1. livsområde) Om 1 måned</label>
                          <textarea
                            onChange={(event: any) => this.answer(21, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[21]}
                          />
                        </div>
                        <h3>2. Livsområde</h3>
                        <div className="roadmapQuestion">
                          <label>22) 2. Livsområde Det livsområde du har valgt at fokusere på, som det næst vigtigste i år.</label>
                          <textarea
                            onChange={(event: any) => this.answer(22, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[22]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>23) 2. Livsområde: Drøm Hvad er din drøm indenfor dit andet livsområde?</label>
                          <textarea
                            onChange={(event: any) => this.answer(23, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[23]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>24) 2. Livsområde: Mål om 5 år Hvad er dit mål om 5 år indenfor dit andet livsområde?</label>
                          <textarea
                            onChange={(event: any) => this.answer(24, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[24]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>25) 2. Livsområde: Mål om 1 år (Kun ét) Hvad er dit mål om 1 år indenfor dit andet livsområde?</label>
                          <textarea
                            onChange={(event: any) => this.answer(25, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[25]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>26) Delmål (indenfor 2. livsområde) Om 11 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(26, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[26]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>27) Delmål (indenfor 2. livsområde) Om 10 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(27, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[27]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>28) Delmål (indenfor 2. livsområde) Om 9 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(28, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[28]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>29) Delmål (indenfor 2. livsområde) Om 8 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(29, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[29]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>30) Delmål (indenfor 2. livsområde) Om 7 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(30, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[30]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>31) Delmål (indenfor 2. livsområde) Om 6 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(31, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[31]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>32) Delmål (indenfor 2. livsområde) Om 5 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(32, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[32]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>33) Delmål (indenfor 2. livsområde) Om 4 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(33, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[33]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>34) Delmål (indenfor 2. livsområde) Om 3 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(34, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[34]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>35) Delmål (indenfor 2. livsområde) Om 2 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(35, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[35]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>36) Delmål (indenfor 2. livsområde) Om 1 måned</label>
                          <textarea
                            onChange={(event: any) => this.answer(36, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[36]}
                          />
                        </div>
                        <h3>3. Livsområde</h3>
                        <div className="roadmapQuestion">
                          <label>37) 3. Livsområde Det livsområde du har valgt at fokusere på, som det tredje vigtigste i år.</label>
                          <textarea
                            onChange={(event: any) => this.answer(37, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[37]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>38) 3. Livsområde: Drøm Hvad er din drøm indenfor dit tredje livsområde.</label>
                          <textarea
                            onChange={(event: any) => this.answer(38, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[38]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>39) 3. Livsområde: Mål om 5 år Hvad er dit mål om 5 år indenfor dit tredje livsområde?</label>
                          <textarea
                            onChange={(event: any) => this.answer(39, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[39]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>40) 3. Livsområde: Mål om 1 år (Kun ét) Hvad er dit mål om 1 år indenfor dit tredje livsområde?</label>
                          <textarea
                            onChange={(event: any) => this.answer(40, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[40]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>41) Delmål (indenfor 3. livsområde) Om 11 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(41, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[41]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>42) Delmål (indenfor 3. livsområde) Om 10 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(42, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[42]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>43) Delmål (indenfor 3. livsområde) Om 9 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(43, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[43]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>44) Delmål (indenfor 3. livsområde) Om 8 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(44, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[44]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>45) Delmål (indenfor 3. livsområde) Om 7 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(45, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[45]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>46) Delmål (indenfor 3. livsområde) Om 6 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(46, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[46]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>47) Delmål (indenfor 3. livsområde) Om 5 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(47, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[47]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>48) Delmål (indenfor 3. livsområde) Om 4 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(48, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[48]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>49) Delmål (indenfor 3. livsområde) Om 3 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(49, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[49]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>50) Delmål (indenfor 3. livsområde) Om 2 måneder</label>
                          <textarea
                            onChange={(event: any) => this.answer(50, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[50]}
                          />
                        </div>
                        <div className="roadmapQuestion">
                          <label>51) Delmål (indenfor 3. livsområde) Om 1 måned</label>
                          <textarea
                            onChange={(event: any) => this.answer(51, event.target.value)}
                            value={this.props.appStore!.roadmap?.answers?.[51]}
                          />
                        </div>
                      </>
                      :
                      <div>No access</div>
                    }
                  </>
                }
              </div>
            </div>
          </div>
        </>
        <StatusSheetPanel
          id={this.props.appStore!.statusSheetToEdit?.id}
        />
      </div >
    );
  }
}